import { createFileRoute, Navigate } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const AdobeExtractionSetupPage = lazy(
  () => import('~/features/onboarding/pages/adobe-extraction-setup-screen'),
);

/** The connection must already exist — every stage reads real files through its
 *  stored credentials, so there is nothing to show without one. */
const searchSchema = z.object({
  connectionId: z.string().optional(),
});

function AdobeExtractionSetupRouteComponent() {
  const { connectionId } = Route.useSearch();

  // Reached without a connection (a stale bookmark, or a back-navigation after
  // the create failed): send them to the connect form rather than rendering a
  // wizard that would 404 on every call.
  if (!connectionId) {
    return <Navigate to="/onboarding/integration/google/adobe-analytics" />;
  }

  return (
    <Suspense fallback={<PageSkeleton />}>
      <AdobeExtractionSetupPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/extraction',
)({
  validateSearch: searchSchema,
  component: AdobeExtractionSetupRouteComponent,
});
